export interface AnimalGroupDefinition {
  key: string;
  name: string;
  color: string;
  image: string;
  accessibilityLabel?: string;
  openAnimalsDirectly?: boolean;
}

const DISPLAY_GROUP_KEY_ALIASES: Record<string, string> = {
  turtle: 'reptiles',
  crocodile: 'reptiles',
};

export const ANIMAL_GROUPS: AnimalGroupDefinition[] = [
  {
    key: 'shark',
    name: 'Sharks',
    color: '#00aeff',
    image: '/images/shark.icon.webp',
  },
  {
    key: 'reptiles',
    name: 'Reptiles',
    color: '#2de181',
    image: '/images/turtle.icon.webp',
  },
  {
    key: 'whale shark',
    name: 'Whale Sharks',
    color: '#e7257d',
    image: '/images/whale.shark.icon.webp',
    openAnimalsDirectly: true,
  },
  {
    key: 'manta ray',
    name: 'Manta Ray',
    color: '#ff9611',
    image: '/images/ray.icon.webp',
    openAnimalsDirectly: true,
  },
  {
    key: 'birds',
    name: 'Birds',
    color: '#a43dd4',
    image: '/images/bird.icon.webp',
  },
];

export function getDisplayAnimalGroupKey(groupKey: string) {
  return DISPLAY_GROUP_KEY_ALIASES[groupKey] ?? groupKey;
}

export const ANIMAL_GROUP_COLOR_MAP = ANIMAL_GROUPS.reduce<Record<string, string>>((acc, group) => {
  acc[group.key] = group.color;
  return acc;
}, {});

Object.entries(DISPLAY_GROUP_KEY_ALIASES).forEach(([groupKey, displayGroupKey]) => {
  ANIMAL_GROUP_COLOR_MAP[groupKey] = ANIMAL_GROUP_COLOR_MAP[displayGroupKey];
});